import { useEffect, useMemo, useState } from "react";
import { Badge, Card, Col, Row, Spinner, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../../services/api";

const AdminProductCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCategories = async () => {
    setLoading(true);

    try {
      const { data } = await api.get("/product-categories");

      const items = Array.isArray(data)
        ? data
        : data?.items || [];

      setCategories(items);
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
        "خطا در دریافت دسته‌های محصولات"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const roots = useMemo(() => {
    return categories
      .filter((category) => !category.parentId)
      .sort((a, b) => {
        if ((a.sortOrder ?? 0) !== (b.sortOrder ?? 0)) {
          return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
        }

        return (a.title || "").localeCompare(
          b.title || "",
          "fa"
        );
      });
  }, [categories]);

  const childrenOf = (parentId) => {
    return categories
      .filter(
        (category) =>
          Number(category.parentId) === Number(parentId)
      )
      .sort((a, b) => {
        if ((a.sortOrder ?? 0) !== (b.sortOrder ?? 0)) {
          return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
        }

        return (a.title || "").localeCompare(
          b.title || "",
          "fa"
        );
      });
  };

  const renderRows = (items, level = 0) => {
    return items.flatMap((category, index) => {
      const children = childrenOf(category.id);

      const row = (
        <tr key={category.code || category.id}>
          <td>{index + 1}</td>

          <td>
            <div
              style={{
                paddingRight: `${level * 30}px`,
              }}
            >
              {level > 0 && (
                <span className="text-muted me-2">
                  ┘─
                </span>
              )}

              <span className="fw-semibold">
                {category.title}
              </span>
            </div>
          </td>

          <td dir="ltr">
            {category.slug || "-"}
          </td>

          <td>
            {category.parent?.title || "دسته اصلی"}
          </td>

          <td>
            {category.sortOrder ?? 0}
          </td>

          <td>
            {category.status === "ACTIVE" ? (
              <Badge bg="success">
                فعال
              </Badge>
            ) : (
              <Badge bg="secondary">
                غیرفعال
              </Badge>
            )}
          </td>

          <td>
            {category.description || "-"}
          </td>
        </tr>
      );

      return [
        row,
        ...renderRows(children, level + 1),
      ];
    });
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <Card className="border-0 shadow-sm">
      <Card.Body>
        <Row className="align-items-center mb-4">
          <Col>
            <h4 className="mb-1">
              دسته‌بندی محصولات
            </h4>

            <p className="text-muted mb-0">
              فهرست دسته‌بندی‌های محصولات
            </p>
          </Col>

          <Col xs="auto">
            <Badge
              bg="light"
              text="dark"
              className="px-3 py-2"
            >
              {categories.length} دسته
            </Badge>
          </Col>
        </Row>

        <div className="table-responsive">
          <Table
            hover
            className="align-middle mb-0"
          >
            <thead>
              <tr>
                <th>#</th>
                <th>عنوان</th>
                <th>Slug</th>
                <th>دسته والد</th>
                <th>ترتیب</th>
                <th>وضعیت</th>
                <th>توضیحات</th>
              </tr>
            </thead>

            <tbody>
              {roots.length > 0 ? (
                renderRows(roots)
              ) : (
                <tr>
                  <td
                    colSpan={7}
                    className="text-center text-muted py-5"
                  >
                    دسته محصولی ثبت نشده است.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default AdminProductCategories;